import en from './en/index';
import bn from './bn/index';

export const messages = {
  en,
  bn,
};
